var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgLb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 268 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2421_5728",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 268,
    height: 207
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.208252,
    width: 268,
    height: 206.48,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2421_5728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.148 187.275C162.389 179.748 161.577 163.202 140.405 157.231C127.894 153.703 120.194 155.57 115.771 158.82C122.381 147.338 126.728 131.44 110.79 125.656C106.659 123.36 93.9454 119.8 76.1344 123.934C83.1355 110.921 90.2067 82.4847 62.4821 72.84C34.7574 63.1953 12.9838 74.3071 5.56252 81.0686C4.44234 71.6919 -4.35115 54.9285 -30.5635 62.8892C-53.4574 67.8646 -68.5799 76.8587 -69 87.3836V187.206L160.148 187.275Z",
    fill: "#D1D048"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLb);
export default __webpack_public_path__ + "static/media/bg-lb.2c01e082c1eab7eabee48d9dd31545b9.svg";
export { ForwardRef as ReactComponent };